export type VisibilityLike = { visible?: boolean; timelineVisible?: boolean };

export function isElementEffectivelyVisible(el: VisibilityLike): boolean {
  const userVisible = el.visible ?? true;
  const timelineVisible = el.timelineVisible ?? true;
  return userVisible && timelineVisible;
}
